import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { Text, Link } from '@ltvco/refresh-lib/theme';
import React, { useContext } from 'react';

import { PLAN_DISPLAY } from '../../../constants';

/**
 * First terms and conditions section content
 * This component extracts just the content (without checkbox) for use in TosInline customTosContent
 */
export const TermsAndConditionsSection1: React.FC = () => {
  const {
    data: { supportPhone, supportEmail },
    links,
  } = useContext(AppConstants);

  return (
    <Text
      variant="body2"
      component="label"
      sx={{ cursor: 'pointer', userSelect: 'none' }}
    >
      You understand that the trial is limited to running{' '}
      {PLAN_DISPLAY.monthlyLimit} reports during the trial period, which lasts{' '}
      {PLAN_DISPLAY.trialPeriod} days. If you would like to cancel before your
      trial ends, you may do so for any reason. Simply call{' '}
      <Link href={`tel:${supportPhone}`} underline="always">
        {supportPhone}
      </Link>
      , email{' '}
      <Link href={`mailto:${supportEmail}`} underline="always">
        {supportEmail}
      </Link>{' '}
      or use our{' '}
      <Link
        href={links?.contactLink}
        underline="always"
        target="_blank"
        rel="noopener noreferrer"
      >
        Contact Us form
      </Link>
      . Otherwise, your trial will end after {PLAN_DISPLAY.trialPeriod} days, at
      which time you will be charged the standard monthly rate of{' '}
      {PLAN_DISPLAY.recurringPrice} plus applicable sales tax. Your membership
      will automatically renew every month thereafter until you cancel, and your
      membership is limited to running {PLAN_DISPLAY.monthlyLimit} reports per
      month.
    </Text>
  );
};

/**
 * Second terms and conditions section content
 * This component extracts just the content (without checkbox) for use in TosInline customTosContent
 */
export const TermsAndConditionsSection2: React.FC = () => {
  const { links } = useContext(AppConstants);

  return (
    <Text
      variant="body2"
      component="label"
      sx={{ cursor: 'pointer', userSelect: 'none' }}
    >
      By clicking the checkbox, you represent that you are over 18 years of age
      and agree to the{' '}
      <Link
        href={links?.tosLink}
        underline="always"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Service
      </Link>
      ,{' '}
      <Link
        href="https://www.bumper.com/nmvtis-disclaimer/"
        underline="always"
        target="_blank"
        rel="noopener noreferrer"
      >
        NMVTIS Disclaimer
      </Link>{' '}
      and{' '}
      <Link
        href={links?.privacyLink}
        underline="always"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </Link>
      , and you agree to receive email from Bumper.com. You also understand that
      Bumper does not guarantee that it has information on any particular
      vehicle, and vehicle history reports are based solely on information
      supplied to Bumper.
    </Text>
  );
};
